<template>
  <div>
    <a-row>
      <g-master name="poll_category"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                ref="master"
                :parentData="ParentData"
      >
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          :label="$t('Tipo de pregunta')"
                          :formItemConfig="fiOptions"
                          :decorator="['id_h_poll_question_type', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                          :params="tipo_pregunta"
              >
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Descripción')">
                <a-input
                  v-decorator="['description', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Respuesta')">
                <a-input
                  v-decorator="['answer', { rules: [{ required: false }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Orden')">
                <a-input
                  v-decorator="['orden', { rules: [{ required: false }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Estado')" :has-feedback="false">
                <a-checkbox
                  v-decorator="['active', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                </a-checkbox>
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </g-master>
      <a-tabs defaultActiveKey="2">
        <a-tab-pane tab="ITEMS" key="1">
          <mantenimiento-poll-question-items v-if="idForm" :id="idForm"></mantenimiento-poll-question-items>
          <span v-else>Seleccione una pregunta para ver más.</span>
        </a-tab-pane>
      </a-tabs>
    </a-row>
    <a-row>
    </a-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        tipo_pregunta: {h_lookup_type: 'TIPO_PREGUNTA'},
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'poll_question',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Tipo de pregunta', dataIndex: 'h_poll_question_type', sorter: true},
              {title: 'Descripción', dataIndex: 'description', sorter: true},
              {title: 'Respuesta', dataIndex: 'answer', sorter: true},
              {title: 'Orden', dataIndex: 'orden', sorter: true},
              {title: 'Estado', dataIndex: 'active_desc', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'active', type: 'boolean'},
            {name: 'answer'},
            {name: 'description'},
            {name: 'orden'},
            {name: 'id_h_poll_question_type'}
          ]
        }
      }
    },
    props: ['id'],
    computed: {
      ParentData () {
        return {
          id_poll_category: this.id
        }
      },
      idForm () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id : null
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Poll/PollQuestion.vue